import { flexRow } from '../../../../common/styles/flex';
import { PlayerSizesTypes } from '../../../../common/store/store.types';

interface StylesObject {
    galleryViewStyle: { [key: string]: any };
    leftArrowWrapperStyle: { [key: string]: any };
    rightArrowWrapperStyle: { [key: string]: any };
    leftArrowStyle: { [key: string]: any };
    rightArrowStyle: { [key: string]: any };
}

const galleryView = {
  ...flexRow,
  marginTop: '4px',
  overflow: 'hidden',
};

const leftArrowWrapper = {
  position: 'absolute',
  display: 'flex',
  zIndex: '1',
  alignItems: 'center',
  backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0))',
  large: {
    width: '40px',
    height: '67px',
  },
  extraLarge: {
    width: '54px',
    height: '86px',
  },
};

const rightArrowWrapper = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row-reverse',
  zIndex: '1',
  alignItems: 'center',
  right: '0px',
  backgroundImage: 'linear-gradient(to left, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0))',
  large: {
    width: '40px',
    height: '67px',
  },
  extraLarge: {
    width: '54px',
    height: '86px',
  },
};

const rightArrow = {
  cursor: 'pointer',
  marginRight: '12px',
};

const leftArrow = {
  cursor: 'pointer',
  marginLeft: '12px',
};

export const getGalleryViewStyleObject = (playerSize: PlayerSizesTypes): StylesObject => {
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return ({
    galleryViewStyle: {
      ...galleryView,
    },
    leftArrowWrapperStyle: [
      leftArrowWrapper,
      largeSize && leftArrowWrapper.large,
      extraLargeSize && leftArrowWrapper.extraLarge,
    ],
    rightArrowWrapperStyle: [
      rightArrowWrapper,
      largeSize && rightArrowWrapper.large,
      extraLargeSize && rightArrowWrapper.extraLarge,
    ],
    leftArrowStyle: {
      ...leftArrow,
    },
    rightArrowStyle: {
      ...rightArrow,
    },
  });
};
